import type { WebSocketConnectionState } from 'common/constants/webSocketConnectionState';
import { useWebSocketConnectionState } from 'common/helpers/webSocketState';

type ReactiveCheckerProps = {
  children: (webSocketState: WebSocketConnectionState) => JSX.Element;
};

export default function ReactiveChecker(props: ReactiveCheckerProps) {
  const webSocketState = useWebSocketConnectionState();
  return props.children(webSocketState);
}
